<template>
  <pie-chart :chartData="chartData" :options="chartConfig" />
</template>

<script>
import { localeString } from '@/config/helpers.js'
import PieChart from '@/components/PieChart.vue'
import { pieColors } from '@/config/colors.js'

export default {
  name: 'PerfilDemograficoChart',
  components: {
    PieChart,
  },
  props: {
    array: Array,
    labelPropertyName: String,
    dataPropertyName: String,
  },
  computed: {
    chartData() {
      return {
        labels: this.array.map((object) => object[this.labelPropertyName]),
        datasets: [
          {
            data: this.array.map((object) => object[this.dataPropertyName]),
            backgroundColor: pieColors,
            borderWidth: 1,
            datalabels: {
              display: true,
            },
          },
        ],
      }
    },
    chartConfig() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
          },
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const total = data.datasets[0].data.reduce((acc, current) => acc + current, 0)
              const label = data.datasets[0].data[tooltipItem.index] || ''
              const value = (label / total) * 100
              return localeString(value, 1) + '% - ' + data.labels[tooltipItem.index]
            },
          },
        },
        plugins: {
          datalabels: {
            backgroundColor: 'rgba(248, 249, 250, 0.82)',
            anchor: 'end',
            align: 'start',
            borderRadius: 4,
            color: 'rgba(0, 0, 0, 0.54)',
            formatter: (value, data) => {
              const total = data.dataset.data.reduce((acc, current) => acc + current, 0)
              const percent = (value / total) * 100
              return localeString(percent, 1) + '%'
            },
          },
        },
      }
    },
  },
}
</script>
